// ============================================================
// APP CONFIG - Change ACTIVE_NETWORK to switch between networks
// User will NEVER see "testnet" - it's just an internal toggle.
// ============================================================

// Options: 'mainnet' | 'testnet'
export const ACTIVE_NETWORK = 'testnet';

export const APP_NAME = 'Zenova';
export const APP_TAGLINE = 'Decentralized Investment Platform';

// ROI polling interval (ms)
export const REFRESH_INTERVAL = 15000;

// Notification durations (ms)
export const NOTIFICATION_DURATION = {
  success: 4000,
  error: 6000,
  info: 4000,
  warning: 5000
};
